import { Upload } from 'antd'
import styles from './index.css'
import { Icon } from '@vzmi/shp_shared_compo'

const Dragger = Upload.Dragger

const ImageDragger = (props) => {
  return (
    <div
      className={props.className}
      data-role='image-dragger'
    >
      <Dragger {...props}>
        <div
          key='btn'
          className={styles.uploadButton}
        >
          <Icon
            name='add-attachments'
            align='text-top'
            color='#5478FC'
            size={20}
          />
          <span>選擇圖片檔案</span>
        </div>
        <p
          key='info'
          className={styles.info}
        >
          或拖曳圖片到框內上傳
        </p>
        {props.children}
      </Dragger>
    </div>
  )
}

export default ImageDragger
